/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Kind_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "No conversation of this type yet." |
*
* @param {Conversations_Kind_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_kind_empty_body = /** @type {((inputs?: Conversations_Kind_Empty_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Kind_Empty_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen gesprek van dit type.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune conversation de ce type pour l'instant.")
	return /** @type {LocalizedString} */ ("No conversation of this type yet.")
});